var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useMemo } from 'react';
import { findCup, useAvailableCupsName } from '@saucerjs/core';
import { useDrag } from 'react-dnd';
import { CupItemSymbol } from './symbol';
import Popover from 'antd/lib/popover';
import _isNil from 'lodash/isNil';
var TemplateMenuItem = React.memo(function (props) {
    var _a;
    var cup = props.cup;
    var _b = useDrag({
        item: { type: CupItemSymbol, name: cup.name },
        collect: function (monitor) { return ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        }); },
    }), opacity = _b[0].opacity, dragRef = _b[1];
    var body = (React.createElement("div", { className: "saucer-template-menu__item", ref: dragRef, style: { opacity: opacity } },
        React.createElement("div", null, (_a = cup.displayName) !== null && _a !== void 0 ? _a : cup.name),
        cup.desc && React.createElement("small", null, cup.desc)));
    var Preview = cup.preview;
    return !_isNil(Preview) ? (React.createElement(Popover, { placement: "rightTop", content: Preview, trigger: "hover" }, body)) : (React.createElement(React.Fragment, null, body));
});
TemplateMenuItem.displayName = 'TemplateMenuItem';
export var TemplateMenu = React.memo(function (props) {
    var availableCupsName = useAvailableCupsName();
    var allCups = useMemo(function () { var _a; return __spreadArrays(availableCupsName, ((_a = props.cupNames) !== null && _a !== void 0 ? _a : [])); }, [availableCupsName, props.cupNames]);
    return (React.createElement("div", { className: "saucer-template-menu", style: props.style }, allCups.map(function (cupName) {
        var cup = findCup(cupName);
        return cup && React.createElement(TemplateMenuItem, { key: cup.name, cup: cup });
    })));
});
TemplateMenu.displayName = 'TemplateMenu';
